export const listInventories = (inventoryList) => {
    return {
        type: 'LIST_INVENTORY',
        inventoryList,
    };
};

export const setLots = (lots) => {
    return {
        type: 'SET_LOTS',
        lots
    };
};

export const setLotItems = (lotItems) => {
    return {
        type: 'SET_LOT_ITEMS',
        lotItems
    };
};

export const setListLotItemsReading = (itemsArray) => {
    return {
        type: 'ADD_LOT_ITEMS_READING_LIST',
        itemsArray,
    };
};

export const addListLotItemsReading = (item) => {
    return {
        type: 'ADD_LOT_ITEMS_READING_LIST',
        item,
    };
};

export const setLotItemsReading = (lotItemsReading) => {
    return {
        type: 'SET_LOT_ITEMS_READING',
        lotItemsReading
    };
};

export const resetLots = () => {
    return {
        type: 'RESET_LOTS'
    };
};
export const selectType = (typeInventory) => {
    return {
        type: 'INVENTORY_SELECT_TYPE',
        typeInventory
    };
};

export const selectInventory = (inventory) => {
    return {
        type: 'INVENTORY_SELECT_INVENTORY',
        inventory
    };
};

export const selectLotInventory = (lot) => {
    return {
        type: 'INVENTORY_SELECT_LOT',
        lot
    };
};

export const setSelectedFilterLotAll = (allLots) => {
    return {
        type: 'INVENTORY_SELECT_LOT_FILTER_ALL',
        allLots
    };
};

export const selectLotItem = (lotItem) => {
    return {
        type: 'INVENTORY_SELECT_LOT_ITEM',
        lotItem
    };
};

export const refreshLot = (lotRefresh) => {
    return {
        type: 'INVENTORY_REFRESH_LOT',
        lotRefresh
    };
};

export const refreshInventoryStatus = (inventoryIdStatus, status) => {
    return {
        type: 'INVENTORY_REFRESH_STATUS',
        inventoryIdStatus,
        status
    };
};

export const changeUserLots = (inventory) => {
    return {
        type: 'INVENTORY_CHANGEUSER_LOTS',
        inventory
    };
};

export const refreshInventory = (inventory) => {
    return {
        type: 'INVENTORY_REFRESH_INVENTORY',
        inventory
    };
};

export const updateLotItemStatus = (lotItem) => {
    return {
        type: 'UPDATE_LOT_ITEMS_STATUS',
        lotItem
    };
};
export const setFilterInventoryLot = (filter) => {
    return {
        type: 'INVENTORY_LOT_FILTER',
        filter,
    };
};

export const resetFilters = () => {
    return {
        type: 'RESET_FILTER_LOT',
    };
};
export const setFilterGeneral = (filter) => {
    return {
        type: 'SET_FILTER_GENERAL',
        filter
    };
};


export const setBalanceData = (balanceData) => {
    return {
        type: 'SET_BALANCE_DATA',
        balanceData,
    };
};

export const selectLog = (log) => {
    return {
        type: 'SELECT_LOG',
        log,
    };
};

export const setLogs = (logs) => {
    return {
        type: 'SET_LOGS',
        logs,
    };
};